












import { Component, Vue, Prop } from "vue-property-decorator";
import { configService } from "../helpers";

const STRIPE_KEY = configService.stripeKey;

@Component
export default class StripePayment extends Vue {
  stripe: any;
  elements: any;
  cardElement: any;

  @Prop(String) private clientSecret!: string;
  @Prop(Object) private user!: any;
  @Prop(String) private stripeAccount?: string;

  created() {
    console.log('created!');
    const locale = this.$i18n.locale;
    let opts = {};
    if (
      [
        "ar",
        "da",
        "de",
        "en",
        "es",
        "fi",
        "fr",
        "he",
        "it",
        "ja",
        "nl",
        "no",
        "pl",
        "ru",
        "sv",
        "zh"
      ].includes(this.$i18n.locale)
    ) {
      opts = {
        locale: this.$i18n.locale
      }
    }

    if (this.stripeAccount) opts['stripeAccount'] = this.stripeAccount;
    this.stripe = Stripe(STRIPE_KEY, opts);
    console.log(this.stripeAccount);
    this.elements = this.stripe.elements();
  }

  mounted() {
    const style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#BA324F",
        iconColor: "#BA324F"
      }
    };

    this.cardElement = this.elements.create("card", { style: style });
    this.cardElement.mount("#card-element");
    this.cardElement.addEventListener("change", (event: any) => {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        this.$emit("paymentOK", false);
        switch (event.error.code) {
          default:
            displayError!.textContent = event.error.message;
            break;
        }
      } else {
        const paymentOK = event.complete && !event.empty ? true : false;
        this.$emit("paymentOK", paymentOK);
        displayError!.textContent = "";
      }
    });
  }
  beforeDestroy() {
    this.cardElement.destroy();
  }

  stripePaymentHandler() {
    return this.stripe.handleCardPayment(this.clientSecret, this.cardElement, {
      payment_method_data: {
        billing_details: {
          name: `${this.user["name"]} ${this.user["surname"]}`
        }
      },
      receipt_email: this.user["email"]
    });
  }
}
